export const STATUS_ITEMS = [
  {
    label: '公開',
    value: 'published',
  },
  {
    label: '非公開',
    value: 'closed',
  },
];

export const TAB_ITEMS = [
  {
    label: 'プロフィール',
    value: 'profile',
  },
  {
    label: 'タイムライン',
    value: 'timeline',
  },
  {
    label: '提案求人',
    value: 'offer',
  },
  {
    label: 'マッチング管理',
    value: 'matching',
  },
  {
    label: 'マイページ',
    value: 'mypage',
  },
] as const;

export const DRAWER_TAB_ITEMS = [
  {
    label: 'プロフィール',
    value: 'profile',
  },
  {
    label: 'タイムライン',
    value: 'timeline',
  },
  {
    label: 'マッチング管理',
    value: 'matching',
  },
] as const;

export const OFFER_STATUS_ITEMS = [
  {
    label: '提案中',
    value: 'suggest',
  },
  {
    label: '応募中',
    value: 'apply',
  },
  {
    label: '辞退',
    value: 'decline',
  },
  {
    label: '取り下げ',
    value: 'archived',
  },
];

export const TIMELINE_STATUS_ITEMS = [
  {
    label: '全て',
    value: 'all',
  },
  {
    label: '面談情報のみ',
    value: 'system',
  },
] as const;

export type TimelineFilter = (typeof TIMELINE_STATUS_ITEMS)[number]['value'];

export const ORDER_ITEMS = [
  { value: 'updated_at', label: '最終更新順' },
  { value: 'id', label: '登録日順' },
  { value: 'job_post_endpoint_created_at', label: '求人提案順' },
  { value: 'job_change_process_updated_at', label: '最終進捗更新順' },
];

export const BOARD_MENU_ITEMS = [
  {
    option: 'nameEdit',
    label: '名前変更',
  },
  {
    option: 'autoSort',
    label: 'オートメーション',
    isContent: true,
  },
  {
    option: 'colorEdit',
    label: 'カラーを変更',
  },
  {
    option: 'delete',
    label: '削除',
  },
];

export const BOARD_CARD_FIELD_ITEMS = [
  { key: 'assignee', label: '担当者' },
  { key: 'company', label: '企業' },
  { key: 'position', label: 'ポジション' },
  { key: 'age', label: '年齢' },
  { key: 'currentSalary', label: '現年収' },
  { key: 'desiredSalary', label: '希望年収' },
] as const;

export type BoardCardFieldKey = (typeof BOARD_CARD_FIELD_ITEMS)[number]['key'];

export const BOARD_CARD_VISIBLE_FIELDS_STORAGE_KEY = 'boardCardVisibleFields';

export const DEFAULT_BOARD_CARD_VISIBLE_FIELDS: Record<BoardCardFieldKey, boolean> = {
  assignee: true,
  company: true,
  position: true,
  age: false,
  currentSalary: false,
  desiredSalary: false,
};

export const COLOR_ITEMS = [
  { value: 'gray', label: 'グレー' },
  { value: 'blue', label: '青' },
  { value: 'green', label: '緑' },
  { value: 'yellow_green', label: '黄緑' },
  { value: 'yellow', label: '黄' },
  { value: 'orange', label: 'オレンジ' },
  { value: 'red', label: '赤' },
  { value: 'pink', label: 'ピンク' },
  { value: 'purple', label: '紫' },
];

export const DIVIDE_STATUS_ITEMS = [
  { value: 'created', label: '登録時' },
  { value: 'suggested', label: '求人提案時' },
  { value: 'approved', label: '応募アクション時' },
  { value: 'processing', label: 'マッチング時' },
  { value: 'offered', label: '内定時' },
  { value: 'closed', label: '内定承諾時' },
  { value: 'finished', label: '転職活動終了' },
  { value: 'not_divided', label: 'なし' },
];

export const CONTRACT_STATUS_ITEMS = [
  { value: 'contracted', label: '契約済' },
  { value: 'nothing', label: '契約なし' },
  { value: 'other', label: 'その他' },
];
